import { render, staticRenderFns } from "./editUsuario.vue?vue&type=template&id=70982be3&scoped=true"
import script from "./editUsuario.vue?vue&type=script&lang=js"
export * from "./editUsuario.vue?vue&type=script&lang=js"
import style0 from "./editUsuario.vue?vue&type=style&index=0&id=70982be3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70982be3",
  null
  
)

export default component.exports